import { useEffect, useState } from "react";
import { Box, Typography, Paper, Chip, Link as MuiLink, CircularProgress, Alert } from "@mui/material";
import { Link } from "react-router-dom";
import DescriptionIcon from "@mui/icons-material/Description";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import logoNegativo from "../../assets/ttflow-logo-negativo@3x.png";
import { fetchTermsVersions, termsFileUrl } from "../../services/termsService";

function formatDate(v) {
  if (!v) return "";
  return new Date(v).toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

export default function TermsPage() {
  const [versions, setVersions] = useState(null);
  const [error,    setError]    = useState(false);

  useEffect(() => {
    fetchTermsVersions()
      .then((data) => setVersions(Array.isArray(data) ? data : []))
      .catch(() => setError(true));
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0b1220", color: "#e2e8f0", py: 6, px: 2 }}>
      <Box sx={{ maxWidth: 720, mx: "auto" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 5 }}>
          <img src={logoNegativo} alt="TTflow" style={{ height: 40 }} />
          <MuiLink component={Link} to="/" sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#94a3b8", fontSize: 13, textDecoration: "none", "&:hover": { color: "#e2e8f0" } }}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Voltar
          </MuiLink>
        </Box>

        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
          Termos de Uso e Política de Privacidade
        </Typography>
        <Typography sx={{ color: "#94a3b8", mb: 4 }}>
          Histórico de versões publicadas. A versão mais recente é a vigente.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ borderRadius: 2 }}>
            Não foi possível carregar as versões dos termos. Tente novamente mais tarde.
          </Alert>
        )}

        {!error && versions === null && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress size={28} sx={{ color: "#2dd4bf" }} />
          </Box>
        )}

        {!error && versions !== null && versions.length === 0 && (
          <Typography sx={{ color: "#94a3b8" }}>Nenhuma versão publicada ainda.</Typography>
        )}

        {!error && versions !== null && versions.length > 0 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {versions.map((v, i) => (
              <Paper
                key={v.id}
                component="a"
                href={termsFileUrl(v.id)}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 2.5,
                  borderRadius: 2,
                  bgcolor: "#101a2e",
                  border: "1px solid #1e293b",
                  textDecoration: "none",
                  color: "inherit",
                  transition: "border-color 0.15s",
                  "&:hover": { borderColor: "#2dd4bf" },
                }}
              >
                <DescriptionIcon sx={{ color: "#2dd4bf" }} />
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                      Versão {v.version}
                    </Typography>
                    {i === 0 && (
                      <Chip label="Vigente" size="small" sx={{ bgcolor: "rgba(45,212,191,0.15)", color: "#2dd4bf", fontWeight: 700, fontSize: 11, height: 20 }} />
                    )}
                  </Box>
                  <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>
                    Vigente a partir de {formatDate(v.effective_date)}
                  </Typography>
                </Box>
              </Paper>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}
